import "./header.css";
import React, { useState, useRef, useEffect } from "react";
import csaszartlogo from "../../../src/pages/homepage/fotok/csaszart_logo_original.png";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPermission } from "../../store/store";
import { useNavigate } from "react-router-dom";

export function Header() {
  const navigate = useNavigate();
  const divRef = useRef(null);
  const travelDropdownRef = useRef(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobileMenuExiting, setIsMobileMenuExiting] = useState(false);
  const [rotate, setRotate] = useState(false);
  const [travelMenuOpen, setTravelMenuOpen] = useState(false);
  const [mobileTravelMenuOpen, setMobileTravelMenuOpen] = useState(false);

  // ÚJ: State, amely figyeli, hogy görgettünk-e már
  const [scrolled, setScrolled] = useState(false);

  // Mobilmenühöz tartozó kint-kattintás
  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      if (mobileMenuOpen) toggleMobileMenu();
    }
    if (travelDropdownRef.current && !travelDropdownRef.current.contains(event.target)) {
      setTravelMenuOpen(false);
    }
  };

  useEffect(() => {
    if (mobileMenuOpen || travelMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileMenuOpen, travelMenuOpen]);

  // Mobilmenü nyit/zár
  const toggleMobileMenu = () => {
    if (mobileMenuOpen) {
      setIsMobileMenuExiting(true);
      setRotate(false);
      setTimeout(() => {
        setMobileMenuOpen(false);
        setIsMobileMenuExiting(false);
        setMobileTravelMenuOpen(false);
      }, 1800);
    } else {
      setMobileMenuOpen(true);
      setRotate(true);
    }
  };

  const navigateToTravelType = (type, isMobile = false) => {
    navigate(`/?type=${type}`);
    setTravelMenuOpen(false);
    if (isMobile && mobileMenuOpen) {
      toggleMobileMenu();
    }
  };

  // ÚJ: Görgetésfigyelés
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Redux admin
  const dispatch = useDispatch();
  const isAdmin = useSelector((state) => state.permission.isAdmin);

  // Ha admin, ez a nav
  if (isAdmin) {
    return (
      <nav>
        <div className={`head ${scrolled ? "scrolled" : ""}`}>
          <Link to="/">
            <img className="lipicslogo" src={csaszartlogo} alt="Csaszar Travel Logo" />
          </Link>
          <ul className="header-bar">
            <li style={{ color: "black" }}>Üdv Admin!</li>
            <li className="menu">
              <Link to="/admin">Admin</Link>
            </li>
          </ul>
        </div>
      </nav>
    );
  } 
  // Ha nem admin, ez a nav
  else {
    return (
      <nav>
        {/* Asztali nézet */}
        <div className={`head ${scrolled ? "scrolled" : ""}`}>
          <div className="head-container">
          <Link to="/">
            <img className="lipicslogo" src={csaszartlogo} alt="Csaszar Travel Logo" />
          </Link>
          <ul className="header-bar">
            <li className="menu menu-dropdown" ref={travelDropdownRef}>
              <button
                type="button"
                className="menu-dropdown__trigger"
                onClick={() => setTravelMenuOpen((prev) => !prev)}
              >
                Útjaink
              </button>
              {travelMenuOpen && (
                <div className="menu-dropdown__panel">
                  <button type="button" onClick={() => navigateToTravelType("one")}>
                    Egy napos
                  </button>
                  <button type="button" onClick={() => navigateToTravelType("multi")}>
                    Több napos
                  </button>
                  <button type="button" onClick={() => navigateToTravelType("plane")}>
                    Repülős
                  </button>
                </div>
              )}
            </li>
            <li className="menu">
              <Link to="/naptar">Naptár</Link>
            </li>
            <li className="menu-uaz">
              <Link to="/rolunk">Rólunk</Link>
            </li>
            <li className="menu">
              <Link to="/kapcsolat">Kapcsolat</Link>
            </li>
            {/*<li className="menu-foglalas">
              <Link to="/foglalas">Foglalás</Link>
            </li>*/}
          </ul>
          </div>
        </div>

        {/* MOBIL HEADER */}
        <div className={`head-mobile ${scrolled ? "scrolled" : ""}`}>
        <div className="head-container">
          <Link to="/">
            <img className="lipicslogo" src={csaszartlogo} alt="Csaszar Travel Logo" />
          </Link>
          <div className="mobile-szoveg-menu-container-up">
            <div
              className={`mobile-szoveg-menu-container ${rotate ? "megfordul" : "visszafordul"}`}
              onClick={toggleMobileMenu}
            >
              <div className="mobile-menu-icon"></div>
            </div>
            </div>
          </div>

          {/* A lenyíló mobil menü */}
          {mobileMenuOpen ? (
            <div
              ref={divRef}
              className={`mobile-menu-container ${
                isMobileMenuExiting
                  ? "slideoutMoAni"
                  : mobileMenuOpen
                  ? "slideinMoAni"
                  : ""
              }`}
            >
              <div className="mobile-menu-features-container">
                <h2
                  onClick={() => {
                    setMobileTravelMenuOpen((prev) => !prev);
                  }}
                >
                  Útjaink
                </h2>
                {mobileTravelMenuOpen && (
                  <div className="mobile-submenu">
                    <button
                      type="button"
                      onClick={() => {
                        navigateToTravelType("one", true);
                      }}
                    >
                      Egy napos
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        navigateToTravelType("multi", true);
                      }}
                    >
                      Több napos
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        navigateToTravelType("plane", true);
                      }}
                    >
                      Repülős
                    </button>
                  </div>
                )}
                <h2
                  onClick={() => {
                    navigate("/naptar");
                  }}
                >
                  Naptár
                </h2>

                <h2
                  onClick={() => {
                    navigate("/rolunk");
                  }}
                >
                  Rólunk
                </h2>

                <h2
                  onClick={() => {
                    navigate("/kapcsolat");
                  }}
                >
                  Kapcsolat
                </h2>
                  {/*}
                <h2
                  className="arajanlat-menu"
                  onClick={() => {
                    navigate("/foglalas");
                  }}
                >
                  Foglalás
                </h2>
  */}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </nav>
    );
  }
}
